export const ROLE_TYPE = {
  ORGANIZATION: 'ORGANIZATION',
  SYSTEM: 'SYSTEM',
};

export const MASTER_ROLE = {
  [ROLE_TYPE.SYSTEM]: 'SUPER_ADMIN',
  [ROLE_TYPE.ORGANIZATION]: 'OWNER',
};
